import { Icon } from "@repo/ui/components/icon";
import { cn } from "@repo/ui/lib/utils";
import { Avatar, AvatarFallback, AvatarImage } from "@repo/ui/ui/avatar";

type OrgAvatarProps = {
  name?: string | null;
  logo?: string | null;
  className?: string;
  fallbackClassName?: string;
};

/** Squared avatar for workspaces/orgs. Control size via `className` (e.g. `size-6`). Pass rounding overrides (e.g. `rounded-sm after:rounded-sm`) via `className`. */
export const OrgAvatar = ({
  name,
  logo,
  className,
  fallbackClassName,
}: OrgAvatarProps) => {
  const initial = name?.charAt(0)?.toUpperCase();
  return (
    <Avatar
      className={cn(
        "overflow-hidden rounded-sm after:rounded-sm after:border-none",
        className,
      )}
    >
      {logo && (
        <AvatarImage
          src={logo}
          alt={name ?? undefined}
          className="rounded-sm border-none"
        />
      )}
      <AvatarFallback className={cn("rounded-sm", fallbackClassName)}>
        {initial ?? (
          <Icon name="building" className="size-1/2 text-muted-foreground" />
        )}
      </AvatarFallback>
    </Avatar>
  );
};
